export const NOTIFICATION_ROOM_TYPE_GAMES = ['PUBG', 'KART'];
